module.exports = __webpack_public_path__ + "img/gg.7f0b3333.svg";